module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"@pakhshkit-js/pakhshkit-js","commonjs2":"@pakhshkit-js/pakhshkit-js","amd":"pakhshkit-js","root":["VidiunPlayer","core"]}
// module id = 1
// module chunks = 0


// WEBPACK FOOTER //
// kava/external {"commonjs":"@pakhshkit-js/pakhshkit-js","commonjs2":"@pakhshkit-js/pakhshkit-js","amd":"pakhshkit-js","root":["VidiunPlayer","core"]}